
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(5(2813|3390|4444)|6(5941|7451|9885)|3(0298|3358|6031|7674)|9((24|97)58|5573|874)|(264|438)12|(2906|417|8678)3|13244|14291|73228|75951|89460)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
